import { render, staticRenderFns } from "./T1TabOfferCard.vue?vue&type=template&id=560a836c&scoped=true&"
import script from "./T1TabOfferCard.vue?vue&type=script&lang=js&"
export * from "./T1TabOfferCard.vue?vue&type=script&lang=js&"
import style0 from "./T1TabOfferCard.vue?vue&type=style&index=0&id=560a836c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a836c",
  null
  
)

export default component.exports